module.exports = __webpack_public_path__ + "static/addAccounts-6794d07d37f3a248511828b8832be723.png";